import { combineReducers } from 'redux';

// reducer import
import customizationReducer from './customizationReducer';
import startupDetailsReducer from './startupDetailsReducer';
import permissionsReducer from './permissionsReducer';
import progressReducer from './progressReducer';
import dataRoomReducer from './dataRoomReducer';
import { RESET_STATE } from './actions';

// ==============================|| COMBINE REDUCER ||============================== //

const appReducer = combineReducers({
    customization: customizationReducer,
    startupDetails: startupDetailsReducer,
    permissions: permissionsReducer,
    progress: progressReducer,
    dataRoom: dataRoomReducer
});


const reducer = (state, action) => {
    if (action.type === RESET_STATE) {
        state = {
            customization: { opened: false },
            startupDetails: { data: null, investor_types: [], is_subscribed: null, all_plans: null },
            permissions: { template: null, userPermissions: null },
            progress: {
                progressData: null,
                requiredFields: [],
                completionPercentage: 0,
                round_id: null
            },
            dataRoom: { list: [] }
        }; // Set state to undefined to reset all reducers
    }
    return appReducer(state, action);
};


export default reducer;
